import React from 'react';
import { CATALOG_GROUP_FALLBACK_ICON, CATALOG_GROUP_ICON_MAP } from './constants';

interface CatalogGroupIconProps {
    icon: string;
}

/*
 * Resolves a catalog group's backend `icon` key to its react-icons component and renders it,
 * falling back to the default group icon when the key is unrecognized.
 */
export function CatalogGroupIcon({ icon }: CatalogGroupIconProps) {
    const Icon = CATALOG_GROUP_ICON_MAP[icon] ?? CATALOG_GROUP_FALLBACK_ICON;
    return <Icon />;
}
